import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// api
import BaseApi from '../api/BaseApi';
// components
import BlogCard from './BlogCard';
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
// helpers
import { addBreadcrumbSchema } from '../helpers';

const BlogPage = () => {
  const { t } = useTranslation('global');

  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [positionFrom, setPositionFrom] = useState(0);

  const postsPerPage = 9;

  const indexOfFirstPost = positionFrom + 1;
  const indexOfLastPost = (positionFrom + postsPerPage) >= totalCount ? totalCount : (positionFrom + postsPerPage);

  const handlePageChange = async positionNumber => {
    try {
      setLoading(true);
      setPositionFrom(positionNumber);

      const response = await axios.get(
        BaseApi + '/blog',
        { params: { page: positionNumber / postsPerPage + 1 } },
      );

      setLoading(false);
      setCardData(response.data.response.Blog.data);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching list of categories', error);
    }
  };

  useEffect(() => {
    const getCardData = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          BaseApi + '/blog',
        );

        setLoading(false);
        setCardData(response.data.response.Blog.data);
        setTotalCount(response.data.response.Blog.pagination.total);
        setPositionFrom(response.data.response.Blog.pagination.current_page * postsPerPage - postsPerPage);
      } catch (error) {
        setLoading(false);

        console.error('Error getting blog data', error);
      }
    };

    const metaTitle = document.querySelector('title');
    const metaDescription = document.querySelector('meta[name="description"]');

    if (metaTitle) {
      metaTitle.textContent = t('blogPage.metaTitleValue');
    }

    if (metaDescription) {
      metaDescription.content = t('blogPage.metaDescriptionValue');
    }

    getCardData();

    const breadcrumbs = [
      { name: t('navHeaders.blog') },
    ];

    const script = addBreadcrumbSchema(breadcrumbs);

    return () => {
      if (script) document.head.removeChild(script);
    };
  }, [t]);

  return (
    <>
      <NavBar />
      {
        loading
          ? (
            <div className='loader-container'></div>
          ) : (
            <>
              <div className='blogPageSection1 text-center'>
                <h1>{t('navHeaders.blog')}</h1>
                <h6 className='text-muted fw-normal'>
                  <Link to='/' style={{ color: 'grey' }}>
                    {t('navHeaders.home')}
                  </Link>
                  {' / '}
                  {t('navHeaders.blog')}
                </h6>
              </div>
              <div className='blogPageSection2 container'>
                <div className='row'>
                  {
                    cardData?.map((i, index) => (
                      <div className='col-lg-4 col-md-6 mb-5' key={index}>
                        <BlogCard
                          id={i.id}
                          tag={i.tag}
                          slug={i.slug}
                          image={i.image}
                          title={i.title}
                          status={i.status}
                          created={i.created}
                          meta_title={i.meta_title}
                          description={i.description}
                          meta_keyword={i.meta_keyword}
                          meta_description={i.meta_description}
                        />
                      </div>
                    ))
                  }
                </div>
              </div>
              {/* Custom Pagination */}
              <div className='blogPagination'>
                <p className='text-muted paginationDetail'>
                  {t('pagination.NoofRecords')}
                  {' '}
                  {indexOfFirstPost} - {indexOfLastPost}
                  {' '}{t('pagination.of')}{' '}
                  {totalCount}
                </p>
                <div className='blogPaginationButtons'>
                  <button
                    className='navButton1'
                    disabled={positionFrom === 0}
                    onClick={() => handlePageChange(indexOfFirstPost - postsPerPage - 1)}
                  >
                    {t('pagination.Prev')}
                  </button>
                  <button
                    className='navButton1'
                    disabled={indexOfLastPost >= totalCount}
                    onClick={() => handlePageChange(indexOfFirstPost + postsPerPage - 1)}
                  >
                    {t('pagination.Next')}
                  </button>
                </div>
              </div>
              <Footer />
            </>
          )
      }
    </>
  );
};

export default BlogPage;
